import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {orbitaxConnectRoutes} from '@features/orbitax-connect/orbitax-connect.routes';
import {SharedModule} from '@shared/shared.module';
import {ParticleService} from '@core/services/particle.service';
import {CommandService} from '@core/services/command.service';
import {IPlatformApiProvider, PlatformApiProvider} from '@shared/services/platform-api-provider';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {OrbitaxConnectToolHandler} from '@features/orbitax-connect/services/orbitax-connect-tool-handler';
import {OrbitaxConnectOtpToolHandler} from '@features/orbitax-connect/services/orbitax-connect-otp-tool-handler';
import {OrbitaxConnectDynamicComponentHelper} from '@features/orbitax-connect/orbitax-connect-dynamic-component-helper';
import {ShowArchiveConnectionsCommandHandler} from '@features/orbitax-connect/command-handlers/show-archived-connections-command-handler';
import { OrbitaxConnectTileViewerComponent } from './components/orbitax-connect-tile-viewer/orbitax-connect-tile-viewer.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { OrbitaxConnectDialogDefinitionFormViewComponentComponent } from './components/orbitax-connect-dialog-definition-form-view-component/orbitax-connect-dialog-definition-form-view-component.component';
import { OrbitaxConnectStepByStepChecklistComponent } from './components/orbitax-connect-step-by-step-checklist/orbitax-connect-step-by-step-checklist.component';

class OrbitaxConnectApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/orbitax-connect')) {
      return 'FileStoreApi';
    }
    return '';
  }
}

@NgModule({
  declarations: [OrbitaxConnectTileViewerComponent, OrbitaxConnectStepByStepChecklistComponent,OrbitaxConnectDialogDefinitionFormViewComponentComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(orbitaxConnectRoutes),
    SharedModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule
  ],
    exports: [
    MatCardModule,
    MatButtonModule,
    MatDividerModule
  ]
})
export class OrbitaxConnectModule {
  constructor(private particleService: ParticleService,
              private commandService: CommandService,
              private platformApiProvider: PlatformApiProvider,
              private showArchivedConnectionsCommandHandler: ShowArchiveConnectionsCommandHandler,
              orbitaxConnectToolHandler: OrbitaxConnectToolHandler,
              orbitaxConnectOtpToolHandler: OrbitaxConnectOtpToolHandler) {
    OrbitaxConnectDynamicComponentHelper.init();
    OrbitaxConnectDynamicComponentHelper.register('OrbitaxConnectToolHandler', orbitaxConnectToolHandler);
    OrbitaxConnectDynamicComponentHelper.register('OrbitaxConnectOtpToolHandler', orbitaxConnectOtpToolHandler);
    OrbitaxConnectDynamicComponentHelper.register('ShowArchiveConnectionsCommandHandler', showArchivedConnectionsCommandHandler);
    this.platformApiProvider.register(new OrbitaxConnectApiProvider);
    const createOrbitaxConnectConfigToolLinkCommand = new PlatformCommand('CreateOrbitaxConnectConfigToolLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/admin-panel/orbitax-connect-config', createOrbitaxConnectConfigToolLinkCommand);
    const createOrbitaxConnectToolLinkCommand = new PlatformCommand('CreateOrbitaxConnectToolLinkCommand', Api.FileStoreApi);
    this.commandService.registrPlatformLinkCommand('/admin-panel/orbitax-connect', createOrbitaxConnectToolLinkCommand);

    const CreateOrbitaxConnectClientPipelinesToolLinkCommand = new PlatformCommand('CreateOrbitaxConnectClientPipelinesToolLinkCommand', Api.FileStoreApi, );
    CreateOrbitaxConnectClientPipelinesToolLinkCommand.projectId = '[PROJECT_ID]';
    this.commandService.registrPlatformLinkCommand('/orbitax-connect/pipelines', CreateOrbitaxConnectClientPipelinesToolLinkCommand);
  }
}
